import { CircularProgress } from '@mui/material';
import * as st from './styles.module.scss';

type Props = {
  progress?: number;
};

export const Status = ({ progress }: Props): JSX.Element => {
  return (
    <div className={st.status}>
      {progress && progress > 0 ? (
        <>
          <CircularProgress variant="determinate" value={progress} />
          <span>Загружаем видео...</span>
        </>
      ) : (
        <>
          <CircularProgress />
        </>
      )}
    </div>
  );
};
